export const ACTION_EDIT_INFO_ORGANIZATION = 'ACTION_EDIT_INFO_ORGANIZATION';
export const ACTION_EDIT_INFO_ORGANIZATION_SUCCESS = 'ACTION_EDIT_INFO_ORGANIZATION_SUCCESS';
export const ACTION_EDIT_INFO_ORGANIZATION_FAILURE = 'ACTION_EDIT_INFO_ORGANIZATION_FAILURE';

export const ACTION_GET_INFO_ORGANIZATION = 'ACTION_GET_INFO_ORGANIZATION';
export const ACTION_GET_INFO_ORGANIZATION_FAILURE = 'ACTION_GET_INFO_ORGANIZATION_FAILURE';
export const ACTION_GET_INFO_ORGANIZATION_SUCCESS = 'ACTION_GET_INFO_ORGANIZATION_SUCCESS';

export const ACTION_REPLACE_MODULE_CUSTOM_INFOS = 'ACTION_REPLACE_MODULE_CUSTOM_INFOS';